// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"2":"35565bd1","180":"27f5d255","258":"7bd88cc7","434":"68ec2fb7","568":"e0ec2a6c","702":"96c84721"}[chunkId] + ".chunk.js";
};